import { render, staticRenderFns } from "./form-item-print.vue?vue&type=template&id=0d9cc909&scoped=true&"
import script from "./form-item-print.vue?vue&type=script&lang=js&"
export * from "./form-item-print.vue?vue&type=script&lang=js&"
import style0 from "./form-item-print.vue?vue&type=style&index=0&id=0d9cc909&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9cc909",
  null
  
)

export default component.exports